import MapIframeRevealer from '../../../layout-front/common/js/MapIframeRevealer';

export default function () {
	window.dataLayer = window.dataLayer || [];
	let offerDetailModalEl = document.getElementById('offerDetailModal');
	let offerPid = null;
	let isIOS = false;
	if (offerDetailModalEl instanceof HTMLElement) {
		isIOS = offerDetailModalEl.dataset.ios === "1";
		const modal = window.Modal.getOrCreateInstance(offerDetailModalEl);
		document.querySelectorAll('[data-show-offer-detail]').forEach((link) => {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				offerPid = this.getAttribute('data-offer-pid'); // PID nabídky
				const offerId = this.getAttribute('data-offer-id'); // ID nabídky
				const offerDetailModalUrl = this.getAttribute('data-offer-detail-modal-url'); // URL pro načtení modalu

				// Uložení stavu do historie, ale bez přidání nového záznamu
				history.pushState(null, '', window.location.pathname + '#offer-detail');

				// Nette AJAX požadavek
				$.nette.ajax({
					url: offerDetailModalUrl,
					type: 'POST',
					data: {
						offerId: offerId
					},
					success: function (response) {
						MapIframeRevealer();
						link.blur(); //Odstranit focus kvůli chybě s aria-hidden
						if (modal && !modal._isShown) {
							modal.show();
						}

						if (!isIOS) {
							enableModalDragging(offerDetailModalEl, modal);
						}
						setTimeout(() => {
							// Přidání listeneru na odkaz v modálním okně, který přesměruje na detail nabídky
							const detailLink = offerDetailModalEl.querySelector('.full-modal-link');
							const modalBody = offerDetailModalEl.querySelector('.modal-body');
								if (detailLink) {
									modalBody.addEventListener('click', function (e) {

									window.location.href = detailLink.href;
									setTimeout(function() {
										hideAndResetModal(modal, offerDetailModalEl);
									}, 700);
								});
							}
						}, 300);
						window.dataLayer.push({
							event: 'ab_offers_preview_open',
							post_id: offerPid
						});
					},
					error: function (xhr, status, error) {
						console.error(`Chyba při načítání detailu nabídky: ${error}`);
					}
				});
			});
		});

		//Zavřeme modal při kliknutí na tlačítko zpět
		window.addEventListener('popstate', function (event) {
			if (modal._isShown) {
				hideAndResetModal(modal, offerDetailModalEl);
			}
		});

		//Safari iOS: Pagehide je event, který se na iOS spouští při přechodu na jinou stránku (včetně swipe zpět).
		window.addEventListener('pagehide', function () {
			if (modal._isShown) {
				hideAndResetModal(modal, offerDetailModalEl);
			}
		});

		//Safari iOS Hack: Zavře modal, pokud stránka přejde do neaktivního stavu (zpět)
		document.addEventListener('visibilitychange', function () {
			if (document.visibilityState === 'hidden' && modal._isShown) {
				hideAndResetModal(modal, offerDetailModalEl);
			}
		});

		//Po zobrazení modalu nastavíme overflow-y na auto, aby bylo možné scrollovat až do konce obsahu.
		offerDetailModalEl.addEventListener('shown.bs.modal', function () {
			this.querySelector('.modal-body').style.setProperty('overflow-y', 'auto', 'important');
			this.querySelector('.modal-body').style.setProperty('padding-bottom', '1.5rem', 'important');
		});

		//Po zavření modalu odstraníme "#offer-detail" z URL
		offerDetailModalEl.addEventListener('hidden.bs.modal', function () {
			history.replaceState(null, '', window.location.pathname + window.location.search);
		});

		//Funkce pro přidání posunu modálního okna při dotyku - povoleno jen pro Android
		function enableModalDragging(modalElement, modal) {
			const header = modalElement.querySelector('.modal-header');
			const body = modalElement.querySelector('.modal-body');

			let isDragging = false;
			let startY, initialTop, lastY;

			// Anti pull-to-refresh fix
			body.addEventListener('touchstart', (e) => {
				startY = e.touches[0].clientY;
			}, { passive: true });

			body.addEventListener('touchmove', (e) => {
				const currentY = e.touches[0].clientY;
				const deltaY = currentY - startY;

				// Pokud je obsah na vršku a tahne se dolů, zabráníme pull-to-refresh
				if (body.scrollTop === 0 && deltaY > 0) {
					e.preventDefault(); // zabrání pull-to-refresh, ale ponechá scroll dolů
				}
			}, { passive: false });

			// Začátek posunu
			const startDrag = (e) => {
				// Není potřeba preventDefault, chceme umožnit i swipe gestům projít
				const modalTop = parseFloat(window.getComputedStyle(modalElement).top) || 0;
				if (modalTop !== 0) return;

				isDragging = true;

				const touch = e.touches[0];
				startY = touch.clientY;
				lastY = startY;
				initialTop = parseFloat(window.getComputedStyle(modalElement).top) || 0;
			};

			header.addEventListener('touchstart', startDrag);
			body.addEventListener('touchstart', startDrag);

			// Posun modalu
			document.addEventListener('touchmove', (e) => {
				if (!isDragging) return;

				const touch = e.touches[0];
				const deltaY = touch.clientY - startY;
				const currentY = touch.clientY;

				if (currentY > lastY && body.scrollTop === 0) {
					modalElement.style.top = initialTop + deltaY + 'px';
				}

				lastY = currentY;
			}, { passive: false });

			// Ukončení posunu
			document.addEventListener('touchend', () => {
				if (!isDragging) return;
				isDragging = false;

				const screenHeight = window.innerHeight;
				const headerHeight = header.getBoundingClientRect().top;

				modalElement.style.transition = 'top 0.3s ease';

				if (headerHeight > screenHeight / 2) {
					// Zavři modal
					modalElement.style.top = screenHeight + 'px';
					setTimeout(() => {
						hideAndResetModal(modal, modalElement);
					}, 300);
				} else {
					// Reset pozice
					modalElement.style.top = initialTop + 'px';
				}
			});
		}

		if (!isIOS) {
			//swipe gesto dolů
			offerDetailModalEl.setAttribute('swipe', 'true');
			offerDetailModalEl.setAttribute('swipe-threshold', '20');
			offerDetailModalEl.addEventListener('swiped-down', function (event) {
				event.preventDefault();
				event.stopPropagation();
				const body = offerDetailModalEl.querySelector('.modal-body');
				if (body.scrollTop === 0) {
					offerDetailModalEl.classList.add('swiping');
					// Počkáme, až animace skončí
					offerDetailModalEl.querySelector('.modal-dialog').addEventListener('transitionend', function handleTransitionEnd() {
						// Odebereme třídu a zavřeme modal
						offerDetailModalEl.classList.remove('swiping');
						hideAndResetModal(modal, offerDetailModalEl);
						// Odebereme listener, aby se nepřidával opakovaně
						offerDetailModalEl.querySelector('.modal-dialog').removeEventListener('transitionend', handleTransitionEnd);
					});
				}
			});
		}

		// Skrytí a resetování modalu
		function hideAndResetModal(modal, modalElement) {
			if (modal._isShown) {
				modal.hide();
				setTimeout(() => {
					// Resetování stylů po animaci
					if (modalElement) {
						modalElement.style.top = '';
						modalElement.style.transition = '';
						modalElement.classList.remove('swiping');
					}
				}, 350); // Po 350 ms (čas potřebný pro animaci)
			}
		}
	}
}
